'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.beginningOfDay;


// WEBPACK FOOTER //
// ./~/sugar-date/date/beginningOfDay.js